










import { Component, Vue, Prop } from 'vue-property-decorator';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    FooterButton
  }
})
export default class TopFooterButton extends Vue {
  @Prop({ type: Boolean, required: true })
  public enabled!: boolean;
}
